import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { DeleteCarrierContactActions } from 'store/ducks/settings/carrier-contact';

export function* deleteCarrierContactRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.delete,
      `/carrier-contact/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteCarrierContactActions.success(data));
    notify('success', 'Contato deletado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(DeleteCarrierContactActions.failure(errorMessage));
  }
}
